// extracted by mini-css-extract-plugin
export default {"title-section":"cy1+XrxXqX","titleSection":"cy1+XrxXqX"};